import './Rex.scss';

import React, {Component} from 'react';
import PropTypes from 'prop-types';

class DeviceChooser extends Component {
  static defaultProps = {
    devices: []
  };

  static propTypes = {
    devices: PropTypes.array,
    updateForm: PropTypes.any,
    selectedDeviceId: PropTypes.any,
    isDeviceRequiredForGift: PropTypes.bool
  };

  selectDevice = (deviceId) => {
    this.props.updateForm({ selectedDeviceId: deviceId });
  };

  render() {
    const { devices, selectedDeviceId, isDeviceRequiredForGift } = this.props;
    return (
      !isDeviceRequiredForGift ? null : (
        <div className="rx-chooser">
          <h3 className="ea-h3">Valitse laite tai kortti, johon lahja liitetään</h3>
          <div className="device-list ea-radio ea-radio--list">
            <fieldset className="ea-radio ea-radio--list">
              {
                devices.map((item, i) => (
                    <div key={i}>
                      <input
                        type="radio"
                        id={`device-radio-${i}`}
                        checked={item.id === selectedDeviceId}
                        onChange={() => this.selectDevice(item.id)}
                        value={i}
                        name={`device-radio-${i}`}
                      />
                      <label htmlFor={`device-radio-${i}`}>
                        <span className="ea-radio__icon">
                          <span className="ea-radio__icon-inner"/>
                        </span>
                        <div>{item.name}</div>
                      </label>
                    </div>
                  )
                )}
            </fieldset>
          </div>
        </div>
      )
    );
  }
}

export default DeviceChooser;



// WEBPACK FOOTER //
// ./web/js/components/rex/DeviceChooser.js